angular.module('common.filter.certificate', ['common.helper'])
    .filter('certificate', function (CommonHelper) {
        return function(certificate){
            if (!certificate || ((typeof certificate) !== "string")) {
                return certificate;
            }
            certificate = CommonHelper.removeSpaceCharacters(certificate);

            if (certificate.length === 4) {
                return certificate.substr(0,1) + " " + certificate.substr(1,3);
            }

            return certificate;
        };
    })
;


// WEBPACK FOOTER //
// ./app/common/filter/certificate-filter.js